import { actions } from 'store/actions'

export const updateExternalModules = ({ dispatch, externalModule }) =>
  dispatch({ type: actions.EXTERNAL_MODULES_UPDATE, payload: externalModule })

export const unsetExternalModules = ({ dispatch }) =>
  dispatch({ type: actions.EXTERNAL_MODULES_UNSET })
